export default "__VITE_ASSET__HKfb12t6__"